import { ConnectorInfo } from '@blaze-shared/api-contracts-domain';
import { BaseSchema } from '@blaze-shared/schema-domain';
import { BreakWorkflowNode } from '@blaze-shared/workflow-domain';

import {
  WorkflowNodeColumnReference,
  WorkflowNodeNamedInputReference,
  WorkflowNodeParamReference,
  WorkflowNodeTagReference,
} from '../../references/references.models';
import { BaseWorkflowNode, WorkflowNode } from '../../registry/node.registry';

@WorkflowNode('Break')
export class BreakNode extends BaseWorkflowNode<BreakWorkflowNode> {
  getColumnReferences(_schemas: Map<string | symbol, BaseSchema>): WorkflowNodeColumnReference[] {
    return [];
  }

  getTagReferences(_schemas: Map<string | symbol, BaseSchema>): WorkflowNodeTagReference[] {
    return [];
  }

  getParamReferences(
    _schemas: Map<string | symbol, BaseSchema>,
    _connectors: ConnectorInfo[],
  ): WorkflowNodeParamReference[] {
    return [];
  }

  getNamedInputReferences(
    _schemas: Map<string | symbol, BaseSchema>,
  ): WorkflowNodeNamedInputReference[] {
    return [];
  }
}
